import { render, staticRenderFns } from "./KejadianPage.vue?vue&type=template&id=1cc00b07"
import script from "./KejadianPage.vue?vue&type=script&lang=js"
export * from "./KejadianPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports